import { action } from 'satcheljs/lib/legacy';
import { default as getNotesSDK } from '../utils/getNotesSDK';
export default action('createNewNote')(function createNewNote() {
    getNotesSDK().createNote(undefined, '');
});
